import { accountSummarySnapshot } from '../repositories/ams/ams.repository';

export const generateCopilotQuickLoginLink = (assetId: string) => {
  const { companyCode, partnerId, externalAccountId } =
    accountSummarySnapshot();

  const baseLink = `https://copilotgps.com/copilotgps`;

  const paramters: string[] = [];

  const typeParam = `type=CONFIG`;
  const assetIdParam = `AssetID=${encodeURIComponent(assetId)}`;

  paramters.push(typeParam);
  paramters.push(assetIdParam);

  if (externalAccountId === '' || partnerId === null || partnerId === '') {
    const companyParams = `CompanyID=${encodeURIComponent(companyCode)}`;
    paramters.push(companyParams);
  } else {
    const partnerParams = `PartnerID=${encodeURIComponent(partnerId)}`;
    const externalAccountIdParam = `ExternalAccountID=${encodeURIComponent(
      externalAccountId
    )}`;

    paramters.push(partnerParams);
    paramters.push(externalAccountIdParam);
  }

  return `${baseLink}?${paramters.join('&')}`;
};
